















































































































import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { ProvidedToolbarParam } from './types';
import { utilService } from '../util-service';

const cssPrefix = 'sw-content-toolbar';

@Component
export default class SwContentToolbar extends SwExtendedVue {
  @Prop({ type: String, default: 'light' })
  theme: 'light' | 'dark';

  @Prop({ type: Boolean, default: true })
  topBorder: boolean;

  @Prop({ type: Boolean, default: true })
  bottomBorder: boolean;

  @Prop({ type: Boolean, default: false })
  floatExpand: boolean;

  cssPrefix = cssPrefix;

  @Provide()
  toolbarParam: ProvidedToolbarParam = {
    floatExpand: this.floatExpand,
    theme: this.theme,
  };

  @Watch('floatExpand')
  @Watch('theme')
  private syncToolbarParameters() {
    Object.assign<ProvidedToolbarParam, ProvidedToolbarParam>(
      this.toolbarParam,
      {
        floatExpand: this.floatExpand,
        theme: this.theme,
      },
    );
  }

  private hasBriefSlot(): boolean {
    const slot = utilService.getVueScopedSlot(this.$scopedSlots, 'brief');
    return slot.length > 0;
  }
}
